import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { supabase } from '../../supabaseClient';
import { colaboradores } from '../../utils/stageHelpers';
import { EVENT_TYPE_OPTIONS } from './EventTypeBadge';

export default function CalendarFilters({ filters, onChange }) {
  const [businessUnits, setBusinessUnits] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase
        .from('business_units')
        .select('id, nome')
        .order('nome');
      if (!cancelled && !error) setBusinessUnits(data || []);
    })();
    return () => { cancelled = true; };
  }, []);

  const update = (patch) => onChange({ ...filters, ...patch });
  const clearAll = () => onChange({ colaboradorId: 'all', businessUnitId: '', eventType: '' });

  const hasActive =
    (filters.colaboradorId && filters.colaboradorId !== 'all') ||
    !!filters.businessUnitId ||
    !!filters.eventType;

  const selectClass =
    'px-2.5 py-1.5 border border-slate-300 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500';

  return (
    <div className="flex flex-wrap items-center gap-2 p-3 bg-white border border-slate-200 rounded-lg">
      <label className="text-xs text-slate-500 font-medium">Filtros:</label>

      <select
        value={filters.colaboradorId || 'all'}
        onChange={(e) => update({ colaboradorId: e.target.value })}
        className={selectClass}
        title="Filtrar por colaborador"
      >
        {colaboradores.map((c) => (
          <option key={c.value} value={c.value}>{c.label}</option>
        ))}
      </select>

      <select
        value={filters.businessUnitId || ''}
        onChange={(e) => update({ businessUnitId: e.target.value })}
        className={selectClass}
        title="Filtrar por vertical (Áreas / Launches)"
      >
        <option value="">Todas as verticais</option>
        {businessUnits.map((bu) => (
          <option key={bu.id} value={bu.id}>{bu.nome}</option>
        ))}
      </select>

      <select
        value={filters.eventType || ''}
        onChange={(e) => update({ eventType: e.target.value })}
        className={selectClass}
        title="Filtrar por tipo de evento"
      >
        <option value="">Todos os tipos</option>
        {EVENT_TYPE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>

      {hasActive && (
        <button
          onClick={clearAll}
          className="ml-auto px-2.5 py-1.5 text-xs text-slate-600 hover:text-slate-800 hover:bg-slate-100 rounded-lg flex items-center gap-1"
        >
          <X size={12} /> Limpar
        </button>
      )}
    </div>
  );
}
